import gql from "graphql-tag";

export default gql`
  fragment RelatedStoriesFields on Story {
    _id
    title
    slug
    createdAt
    modifiedAt
    lastPublishedAt
    introduction
    medias {
      url
      type
    }
    author {
      ... on VendorUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on GovernmentUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on PendingUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        avatar
      }
    }
    tags {
      _id
      name
      slug
    }
  }
`;
